const ThisLandIsYourLand = [
	'This land is your land, this land is my land,',
	'From California, to the New York Island,',
	'From the Redwood Forest, to the Gulf Stream Waters,',
	'This land was made for you and me.',
	'',
	'I roamed and rambled, and I followed my footsteps',
	'To the sparkling sands of her diamond deserts',
	'And all around me a voice was singing',
	'This land was made for you and me!',
	'',
	'This land is your land, this land is my land,',
	'From California, to the New York Island,',
	'From the Redwood Forest, to the Gulf Stream Waters,',
	'This land was made for you and me.',
	'',
	'As I went walking that ribbon of highway',
	'I saw above me that endless skyway',
	'I saw below me those golden valleys',
	'This land was made for you and me!',
	'',
	'This land is your land, this land is my land,',
	'From California, to the New York Island,',
	'From the Redwood Forest, to the Gulf Stream Waters,',
	'This land was made for you and me.',
	'',
	'As the sun was shining, and I was strolling,',
	'And the wheat fields waving, and the dust clouds rolling,',
	'As the fog was lifting, a voice was saying',
	'"This land was made for you and me!"',
	'',
	'This land is your land, this land is my land,',
	'From California, to the New York Island,',
	'From the Redwood Forest, to the Gulf Stream Waters,',
	'This land was made for you and me.',
];

export default ThisLandIsYourLand;
